import './Landing.sass';

import Slider from 'react-slick';
import { useRef, useState, useMemo, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { sortBy, find } from 'lodash';
import useGlobalState from '../GlobalStates';

import { useAds, useRoutes, useArticles } from '../api';
import { useEffectOnce, useWindowSize } from 'react-use';
import Meta from '../components/Meta';
import jquery from 'jquery';

const Prev = (props) => {
	return <div className='nav prev' onClick={props.onClick} />;
};

const Next = (props) => {
	return <div className='nav next' onClick={props.onClick} />;
};

const Landing = (props) => {
	const [announcements, setAnnouncements] = useState([]);
	const [currentAnnouncement, setCurrentAnnouncement] = useState(false);

	const [globalStates, setGlobalStates] = useGlobalState();

	const closeAnnouncement = () => {
		setCurrentAnnouncement(null);
	};

	const heroSlides = useAds('bigbanner');
	const fundSlides = useAds('fundbanner');
	const linkBlocks = useAds('linkbanner');

	useEffect(() => {
		if (!heroSlides.isLoading && !fundSlides.isLoading && !linkBlocks.isLoading) {
			jquery('.Landing').removeClass('hidePage');
		}
	}, [fundSlides.isLoading, heroSlides.isLoading, linkBlocks.isLoading]);

	const isLoading = useMemo(() => {
		if (!heroSlides.isLoading && !fundSlides.isLoading && !linkBlocks.isLoading) {
			return false;
		}

		return true;
	}, [fundSlides.isLoading, heroSlides.isLoading, linkBlocks.isLoading]);

	const heroSlidesList = useMemo(() => {
		return sortBy(heroSlides.list, 'sortValue');
		// return filter(sorted, (item, index) => {
		// 	return index < 4;
		// });
	}, [heroSlides]);

	const heroSlidesSettings = useMemo(() => {
		return {
			dots: true,
			infinite: true,
			arrows: false,
			speed: 800,
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplay: true,
			autoplaySpeed: 5000,
			pauseOnHover: false,
			fade: true,
			customPaging: (index) => (
				<div className='kv-dot'>
					<div className='text'>{heroSlidesList[index]?.name}</div>
					<div className='mobile-dot'></div>
				</div>
			),
		};
	}, [heroSlidesList]);

	const fundsSlideSettings = useMemo(() => {
		return {
			dots: false,
			infinite: true,
			arrows: false,
			speed: 300,
			slidesToScroll: 1,
			autoplay: false,
			slidesToShow: 3,
			pauseOnHover: false,
			responsive: [
				{
					breakpoint: 1023,
					settings: {
						slidesToShow: 1.5,
						slidesToScroll: 1,
						infinite: false,
					},
				},
				{
					breakpoint: 767,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						centerMode: true,
						centerPadding: '13%',
						infinite: true,
						// fade: true,
					},
				},
			],
		};
	}, []);

	const announcementSlidesSettings = useMemo(() => {
		return {
			dots: false,
			infinite: true,
			arrows: true,
			speed: 800,
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplay: false,
			prevArrow: <Prev />,
			nextArrow: <Next />,
			afterChange: (current) => {
				setCurrentAnnouncement(announcements[current]);
			},
		};
	}, [announcements]);

	const slider = useRef();

	const { flattenedRoutes } = useRoutes();

	const popup = useMemo(() => {
		return find(flattenedRoutes, (route) => {
			return route.url === '/popup' || route.route === '/popup';
		});
	}, [flattenedRoutes]);

	const { articles } = useArticles(popup?.guid || '', popup?.route || '', '', '', '');

	useEffect(() => {
		if (articles && articles.length && !globalStates.landingAnnouncementSeen) {
			const announcements = [];

			articles.forEach((article) => {
				if (article.contents) {
					announcements.push({
						title: article.title,
						content: article.contents,
						url: article.url,
						urlType: article.urlType,
					});
				}
			});

			// announcements.push({
			// 	title: 'test',
			// 	content: '<p>test</p>',
			// })

			setAnnouncements(announcements);
			setCurrentAnnouncement(announcements[0]);

			setGlobalStates({
				...globalStates,
				landingAnnouncementSeen: true,
			});
		}
	}, [articles, globalStates, setGlobalStates]);

	const { width } = useWindowSize();

	const showNavs = useMemo(() => {
		if (width < 1024) return true;
		if (fundSlides.list.length > 3) return true;
		return false;
	}, [width, fundSlides.list]);

	useEffectOnce(() => {
		setTimeout(() => {
			slider.current.slickGoTo(0);
		}, 500);
	});

	return (
		<div className={`Landing ${isLoading ? 'hidePage' : ''}`}>
			<Meta data={props.routeData} />

			<div className='kv-slide-wrap'>
				<Slider {...heroSlidesSettings} className='kv'>
					{heroSlidesList.map((slide) => {
						const { url, guid, pic, picM, descriptionPosition, urlType, description, description2 } = slide;
						// console.log(slide);
						// const slideStyle = {
						// 	'--bg': `url(${pic})`,
						// 	'--bg-m': `url(${picM})`,
						// }
						if (urlType === '_self') {
							return (
								<Link to={url} className='slide' key={guid}>
									<div className='slide-content'>
										<img src={pic} alt='' className='desktop' />
										<img src={picM} alt='' className='mobile' />
										<div className={`text-wrap ${descriptionPosition}`}>
											<div className='title' dangerouslySetInnerHTML={{ __html: description }}></div>
											<div className='sub' dangerouslySetInnerHTML={{ __html: description2 }}></div>
										</div>
									</div>
								</Link>
							);
						}

						return (
							<a href={url} target='_blank' rel='noreferrer noopener' className='slide' key={guid}>
								<div className='slide-content'>
									<img src={pic} alt='' className='desktop' />
									<img src={picM} alt='' className='mobile' />
									<div className={`text-wrap ${descriptionPosition}`}>
										<div className='title' dangerouslySetInnerHTML={{ __html: description }}></div>
										<div className='sub' dangerouslySetInnerHTML={{ __html: description2 }}></div>
									</div>
								</div>
							</a>
						);
					})}
				</Slider>
			</div>

			<div className='common-pad-wrap'>
				<div className='section-heading'>
					<div className='icon'></div>
					<div className='text'>精選基金</div>
				</div>
			</div>

			<div className='funds-slide-wrap'>
				<Slider {...fundsSlideSettings} className='funds' ref={slider}>
					{fundSlides.list.map((slide) => {
						const { guid, pic, name, url, urlType, description } = slide;

						if (urlType === '_self') {
							return (
								<Link to={url} className='slide' key={guid}>
									<div className='ratio-wrap'>
										<div className='img-wrap' style={{ backgroundImage: `url(${encodeURI(pic)})` }}></div>
									</div>

									<div className='text-wrap'>
										<div className='title'>
											{name}
											<div className='subtitle'>{description}</div>
										</div>
									</div>
								</Link>
							);
						}

						return (
							<a href={url} target={urlType} rel='noreferrer noopener' className='slide' key={guid}>
								<div className='ratio-wrap'>
									<div className='img-wrap' style={{ backgroundImage: `url(${encodeURI(pic)})` }}></div>
								</div>

								<div className='text-wrap'>
									<div className='title'>
										{name}
										<div className='subtitle'>{description}</div>
									</div>
								</div>
							</a>
						);
					})}
				</Slider>

				<div className={`navs ${showNavs && 'active'}`}>
					<div
						className='prev'
						onClick={() => {
							slider.current.slickPrev();
						}}></div>
					<div
						className='next'
						onClick={() => {
							slider.current.slickNext();
						}}></div>
				</div>
			</div>

			<div className='sections'>
				{linkBlocks.list.map((block, i) => {
					const { guid, name, pic, url, urlType } = block;

					if (urlType === '_self') {
						return (
							<Link to={url} className='section' key={guid}>
								<div className='pic'>
									<img src={pic} alt='' />
								</div>
								<div className='text'>{name}</div>
							</Link>
						);
					}

					return (
						<a href={url} target={urlType} className='section' key={guid}>
							<div className='pic'>
								<img src={pic} alt='' />
							</div>
							<div className='text'>{name}</div>
						</a>
					);
				})}
			</div>

			<div className={`announcement-wrap ${currentAnnouncement && 'active'}`}>
				<div className='announcement'>
					<div className='title'>{currentAnnouncement?.title}</div>
					<div className='content-wrap'>
						<Slider {...announcementSlidesSettings} className='content'>
							{announcements.map((announcement) => {
								const { url, urlType } = announcement;

								if (urlType === '_self') {
									return (
										<Link to={url} className='content-slide' key={announcement.title}>
											<div
												className='content'
												dangerouslySetInnerHTML={{ __html: announcement.content }}></div>
										</Link>
									)
								}

								if (urlType === '_blank') {
									return (
										<a href={url} target={urlType} rel='noreferrer noopener' className='content-slide' key={announcement.title}>
											<div
												className='content'
												dangerouslySetInnerHTML={{ __html: announcement.content }}></div>
										</a>
									)
								}

								return (
									<div className='content-slide' key={announcement.title}>
										<div
											className='content'
											dangerouslySetInnerHTML={{ __html: announcement.content }}></div>
									</div>
								);
							})}
						</Slider>

						<div className='button-wrap'>
							<div className='button' onClick={closeAnnouncement}>
								關閉
							</div>
						</div>
					</div>
					<div className='close' onClick={closeAnnouncement}></div>
				</div>
			</div>
		</div>
	);
};

export default Landing;
